// extracted by mini-css-extract-plugin
export default {"input":"AcademyTopicInput_input__BDslX"};